export enum UserStatuses {
  New = 1,
  Registered = 2,
  InCompleted = 3,
  Transferred = 4,
  DropOut = 5,
  Blocked = 6,
  Denied = 7,
  Deleted = 8,
  Active = 9
}

